<h2 mat-dialog-title [ngClass]="statusClass">{{ data.title }}</h2>
<mat-dialog-content [ngClass]="statusClass">{{ data.message }}</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ data.oKText }}</button>
</mat-dialog-actions>
